import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { Layout } from './-components/Layout';
import { EditReleaseNotesForm } from './-components/ReleaseNotesForm';

export const Route = createFileRoute('/_authenticated/releasenotes/$id')({
    context: ({ params }) => ({
        releaseNoteQuery: client.releasenotes.releasenote.get.queryOptions(
            { params: { id: Number(params.id) } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.releaseNoteQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: () => (
        <Layout>
            <EditReleaseNotesForm />
        </Layout>
    ),
});
